// extracted by mini-css-extract-plugin
export default {"container":"UploadAvatar_container__daPH0","label":"UploadAvatar_label__15qQZ","button":"UploadAvatar_button__Afv5V","add":"UploadAvatar_add__uM5a6"};